import { database, storage } from '../config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Empresa {
    constructor() {
        this.Telefono = ''
        this.Whatsapp = ''
        this.Celular = ''
        this.Direccion = ''
        this.Descripcion = ''
        this.Correo = ''
        this.horarios = []
    }

    // getInfoEmpresa devuelve la promesa
    getInfoEmpresa(){ 
        return database.collection('infoEmpresa')
            .doc('info')
            .get()
            .then(doc => doc.data())
    }

    guardarInfoEmpresa(data) {
        return database.collection('infoEmpresa').doc('info').set({
            ...data,
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

    guardarImgEmpresa(archivo, actualizarImgProgress){
        const refStorage = storage.ref(`imgEmpresa/${new Date().valueOf() * Math.random()}`)
        const task = refStorage.put(archivo)
        task.on('state_changed',
        snapshot =>{
            const porcentaje = snapshot.bytesTransferred / snapshot.totalBytes *100
            actualizarImgProgress(porcentaje)
        },
        err =>{
            console.error(Error.guardarError(err))
        },
        () =>{
            task.snapshot.ref.getDownloadURL()
            .then(url =>{
                database.collection("imgEmpresa").add({
                    altText: '',
                    caption: '',
                    header: '',
                    src: url
                })
            })
            .catch(err => console.error(Error.guardarError(err)))
        })
    }

    eliminarImgEmpresa(docRef){
        database.collection("imgEmpresa").doc(docRef).delete().then(function() {
            console.log("Document successfully deleted!")
        }).catch(error => Error.guardarError(error))
    }
}